<template>
    <div class="actions">
		<b-modal
			no-close-on-backdrop
			:title="formApproveRO ? 'Customer Approval Info' : 'Do you want to mark this issue as approved ?'"
			class="modal-success"
			v-model="approveActionDlg"
			ok-variant="success"
			:ok-only="formApproveRO ? true : false"
			:ok-title="formApproveRO ? 'Close' : 'Approve'"
			size="lg"
            @ok="onApproveAction"
		>
            <b-container fluid>
                <b-form @submit.prevent="onApproveAction" @reset="onResetAction">
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-1" label="Agreed with" label-for="input-agreed" >
                                <b-form-select id="input-agreed" v-model="formApprove.agreedwith" :options="peoples" />
                            </b-form-group>
                            <b-form-group id="input-group-1" label="Comment" label-for="input-agreed" >
                                <b-form-textarea
                                            id="input-description"
                                            v-model="formApprove.description"
                                            rows="7"
                                            placeholder=""
                                            required
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
		<b-modal
			no-close-on-backdrop
			:title="formDoneRO ? 'Marsilli Done info' : 'Do you want to mark this issue as done ?'"
			class="modal-success"
			v-model="doneActionDlg"
			ok-variant="success"
			:ok-only="formDoneRO ? true : false"
			:ok-title="formDoneRO ? 'Close' : 'Mark Done'"
			size="lg"
            @ok="onDoneAction"
		>
            <b-container fluid>
                <b-form @submit.prevent="onDoneAction" @reset="onResetAction">
                    <b-row>
                        <b-col>
                            <b-form-group id="input-group-1" label="Agreed with" label-for="input-agreed" >
                                <b-form-select id="input-agreed" v-model="formDone.agreedwith" :options="peoples" />
                            </b-form-group>
                            <b-form-group id="input-group-1" label="Comment" label-for="input-agreed" >
                                <b-form-textarea
                                            id="input-description"
                                            v-model="formDone.description"
                                            rows="7"
                                            placeholder=""
                                            required
                                        ></b-form-textarea>
                                </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
		<b-modal
			no-close-on-backdrop
			title="Add Action"
			class="modal-success"
			v-model="addActionDlg"
			ok-variant="success"
			:ok-only="false"
			ok-title="Save"
			size="lg"
            @ok="onSubmitAction"
		>
			<b-container fluid>
                <b-form @submit.prevent="onSubmitAction" @reset="onResetAction">
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Date" label-for="input-date" >
                                <b-form-input id="input-date" v-model="formAction.ts" type="date" placeholder="Insert action date" required />   
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-form-group id="input-group-2" label="Action title" label-for="input-action" >
                                <b-form-input id="input-action" v-model="formAction.action" type="text" placeholder="Insert the description of the action" required />   
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Due Date" label-for="input-due-date" >
                                <b-form-input id="input-due-date" v-model="formAction.duets" type="date" placeholder="Insert due date" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Owner" label-for="input-owner" >
                                        <b-form-select id="input-owner" v-model="formAction.owner" :options="owners" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Category" label-for="input-category" >
                                        <b-form-select id="input-category" v-model="formAction.catid" :options="categories" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Status" label-for="input-status" >
                                <b-form-select id="input-status" v-model="formAction.statusid" :options="statuses" required></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Phase" label-for="input-phase" >
                                        <b-form-select id="input-phase" v-model="formAction.phaseid" :options="phases" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group id="input-group-2" label="Responsible" label-for="input-responsible" >
                                        <b-form-select id="input-responsible" v-model="formAction.respid" :options="responsibles" required></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <b-form-group id="input-group-1" label="Priority" label-for="input-priority" >
                                <b-form-select id="input-priority" v-model="formAction.prioritylevel" :options="priorities" required></b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="9">
                            <b-form-file
                                v-model="file"
                                :state="Boolean(file)"
                                placeholder="Choose a PDF/JPG/ZIP file or drop it here..."
                                drop-placeholder="Drop PDF/JPG/ZIP file here..."
                                accept="application/pdf,application/zip,image/jpeg"
                            ></b-form-file>
                            <div class="mt-3">Selected file: {{ file ? file.name : '' }}</div>
                            <b-button @click="file = null" v-if="Boolean(file)">Reset</b-button>
                        </b-col>
                    </b-row>

                </b-form>
			</b-container>
		</b-modal>
        <b-container fluid>
            <b-row>
                <b-col cols="4">
                    <b-row><b-col><SchedaMacchina v-if="!!machine" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row>
                    <b-row><b-col><OpenActionsStatus v-if="!!machine" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row>
                    <b-row><b-col><OpenPointsMachine v-if="!!machine" :info="false" :key="machine.upd" /></b-col></b-row>
                    <b-row><b-col><Documents /></b-col></b-row>
                </b-col>
                <b-col cols="8">
                    <b-row>
                        <b-col cols="2"><b-button @click="back()" type="submit" variant="primary" >&#x2B11; Back to issues</b-button></b-col>
                        <b-col cols="6" v-if="!!issue">
                            <h2>{{ issue.no }} - {{ issue.issue }}</h2>
                            <h3>SW unit:{{ issue.swunit }} | Owner:{{ issue.owner }} | {{ toYYYYMMDD(issue.duets) }}</h3>
                        </b-col>
                        <b-col cols="2"><b-button @click="cloneAction()" type="submit" variant="primary" v-show="clonable"> CLONE ACTION </b-button></b-col>
                        <b-col cols="2"><b-button @click="addAction()" type="submit" variant="primary" > NEW ACTION </b-button></b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <AgGridVue :style="`width: calc(100% - 0px); height: calc(100vh - 635px)`" 
                                class="ag-theme-alpine" 
                                :columnDefs="columnDefs" 
                                :rowData="actions"
                                :defaultColDef="defaultColDef" 
                                :getRowClass="getRowClass"
                                :suppressColumnVirtualisation="false" 
                                @first-data-rendered="onFirstDataRendered" 
                                @grid-ready="onGridReady"
                                @row-double-clicked="onRowDoubleClicked"
                                @row-clicked="onRowClicked">
                            </AgGridVue>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-row><b-col><Communication v-if="!!machine" :issueid="issue ? issue.id : null" :actionid="currActionId" :m="machine" :info="false" :key="machine.upd" /></b-col></b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import OpenActionsStatus from "@/components/OpenActionsStatus.vue";
import OpenPointsMachine from "@/components/OpenPointsMachine.vue";
import Communication from "@/components/Communication.vue";
import Documents from "@/components/Documents.vue";

export default {
    name: "Actions",
    components: {
        AgGridVue,
        SchedaMacchina,
        OpenActionsStatus,
        OpenPointsMachine,
        Communication,
        Documents,
    },
    data: function () {
        return {
            formApprove: {
                agreedwith: "",
                description: "",
                actionid: null,
            },
            formDone: {
                agreedwith: "",
                description: "",
                actionid: null,
            },
            formApproveRO: false,
            formDoneRO: false,
            editId: 0,
            formAction: {
                no: 0,
                ts: null,
                duets: null,
                action: "",
                owner: "",
                catid: null,
                respid: null,
                phaseid: null,
                statusid: null,
                prioritylevel: 1,
            },
            file: null,
            owners: [{ value: "Marsilli", text: "Marsilli" }, { value: "Customer", text: "Customer" }],
            peoples: [],
            priorities: [],
            phases: [],
            categories: [],
            responsibles: [],
            statuses: [],
            addActionDlg: false,
            approveActionDlg: false,
            doneActionDlg: false,
            gridApi: null,
            columnApi: null,
            defaultColDef: {
                sortable: true,
                filter: true,
				resizable: true, 
            },
            columnDefs: [
                { hide: true, field: "id" },
                { headerName: "No.", width:"80px",field: "no", filter: 'agNumberColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Date", width:"110px",field: "ts", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Due Date", width:"110px",field: "duets", filter: 'agDateColumnFilter',valueFormatter: this.dateFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Action", field: "action", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Owner", width:"110px",field: "owner", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, sort: { direction: 'desc', priority: 0 }, },
                { headerName: "Category", width:"110px",field: "category", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Responsible", width:"110px",field: "responsible", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Phase", width:"110px",field: "phase", filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Status", width:"100px",field: "status", cellClass: 'ag-left-aligned-cell', filter: 'agTextColumnFilter',filterParams: { buttons: ['reset', 'apply'] }, cellRenderer: params => { return `<div style="width: 20px;height: 20px;background-color: ${params.value};border-radius: 50%;margin:10px;border: 2px solid black;"></div>`}},
                { headerName: "Priority", width:"180px",field: "priority", filter: 'agNumberColumnFilter',valueFormatter: this.priorityFormatter,filterParams: { buttons: ['reset', 'apply'] }, },
                { headerName: "Done", width:"110px",field: "donets", onCellClicked: this.onDoneCellClicked, cellClass: params => {return params.value || !this.machine ? 'check' : "pointer check"}, cellRenderer: params => { return params.value ? this.dateFormatter(params) : `&#9633; set`}, },
                { headerName: "Approved", width:"110px",field: "approvedts", onCellClicked: this.onApprovedCellClicked, cellClass: params => {return params.value || !this.machine ? 'check' : "pointer check"}, cellRenderer: params => { return params.value ? this.dateFormatter(params) : `&#9633; set`}, },
                { headerName: "Edit", hide: !this.$store.getters.marsilli, width:"110px",field: "approvedts", onCellClicked: this.onEditCellClicked, cellClass: () => {return "pointer"}, cellRenderer: params => { if(params.data.donets || params.data.approvedts) return ""; else return `&#x1F4DD;`}, },
                { headerName: "Delete", hide: !this.$store.getters.marsilli, width:"110px",field: "approvedts", onCellClicked: this.onDeleteCellClicked, cellClass: () => {return "pointer"}, cellRenderer: params => { if(params.data.donets || params.data.approvedts) return ""; else return `&#x1F5D1;&#xFE0F;`}, },
            ],
            actions: [],
            issue: null,
            currActionId: 0,
            clonable: false,
        }
    },
    props: {
        m: Object,
    },
    computed: {
        machine(){
            return this.$store.getters.machine
        },
        section(){
            return this.$store.getters.section
        },
        marsilli() {
            return this.$store.getters.marsilli
        },
    },
    async mounted(){
        this.issue = this.$store.getters.issue
        console.log("issue",this.issue)

        this.priorities = (await API.getPriorities()).map((p) => ({value:p.level, text:p.description}));
        this.phases = (await API.getPhases(this.section)).map((p) => ({value:p.id, text:p.descr}));
        this.categories = (await API.getCategories()).map((p) => ({value:p.id, text:p.descr}));
        this.statuses = (await API.getStates()).map((p) => ({value:p.id, text:p.descr}));
        this.responsibles = (await API.getResponsibles()).map((p) => ({value:p.id, text:p.descr}));

		this.$nextTick(async () => {
			let k = 1;
            if(this.machine) {
                this.machine.image = "/images/units/" + this.machine.img;
                this.machine.upd = k++;
            }
		});
        if(this.machine)
            this.peoples = (await API.getTeams(this.machine.codice, this.section)).map(p => ({text: `${p.name} ${p.surname} - ${p.email}`, value: p.id}));

        console.log("peoples", this.peoples)

        await this.refreshActions()

        if(this.gridApi)
            this.gridApi.redrawRows() // le priorities sono state disegnate prima di avere i valori !
    },
    methods: {
        async refreshActions(){
            this.actions = await API.pi_Actions(this.issue.id, this.section)
            this.actions = this.actions.map((i,idx) => ({...i, no: idx+1, ts: new Date(i.ts), duets: new Date(i.duets), approvedts: i.approvedts ? new Date(i.approvedts):  null, donets: i.donets ? new Date(i.donets) : null}))
        },
        async onApproveAction(){
            if(this.formApproveRO) return
            console.log("onApproveAction",this.formApprove)
            this.approveActionDlg = false
            await API.pi_actionapprove(this.formApprove.agreedwith, this.formApprove.description, this.formApprove.actionid, this.section)
            await this.refreshActions()
            this.formApprove = {agreedwith: "",description: "",actionid: null}
        },
        async onDoneAction(){
            if(this.formDoneRO) return
            console.log("onDoneAction",this.formDone)
            this.doneActionDlg = false
            await API.pi_actiondone(this.formDone.agreedwith, this.formDone.description, this.formDone.actionid, this.section)
            await this.refreshActions()
            this.formDone = {agreedwith: "",description: "",actionid: null}
        },
        onResetAction(){
            console.log("onResetAction")
            this.addActionDlg = false
        },
        back(){
            this.$router.push("/pinfomacchina");
        },
        addAction(){
            console.log("addAction")
            this.editId = 0
            this.formAction = { issueid:this.issue.id, no: 0, ts: null, duets: null, action: "", owner: "", catid: null, phaseid: null, statusid: null, prioritylevel: 1, },
            this.addActionDlg = true
        },
        cloneAction(){
            console.log("cloneAction")
            let action = this.actions.find(a => a.id == this.currActionId)
            console.log("DUETS", action.duets,new Date(action.duets).toDateString(),this.toYYYYMMDD(new Date(action.duets)))
            this.formAction = { issueid:this.issue.id, no: 0, ts: this.toYYYYMMDD(new Date(action.ts)), duets: this.toYYYYMMDD(new Date(action.duets)), action: action.action+" cloned" , owner: action.owner, catid: action.catid, respid: action.respid, phaseid: action.phaseid, statusid: action.statusid, prioritylevel: action.prioritylevel, },
            this.addActionDlg = true
        },
        toYYYYMMDD(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // mesi da 0 a 11
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        async onSubmitAction(){
            this.formAction.unit = this.machine.codice
            if(this.editId)
                this.formAction.actionid = this.editId
            let actionid = await API.addAction(this.formAction, this.section)

			const formData = new FormData()
			formData.append('upload', this.file)
            formData.append('code', this.formAction.unit)
            formData.append('issueid', this.formAction.issueid)
            formData.append('actionid', actionid)
            formData.append('status', this.section)
			await API.uploadDocument(formData)

            // this.gridApi.redrawRows()
            await this.refreshActions()
            this.addActionDlg = false
            this.$store.commit("incPStates",null);
        },
        dateFormatter(params) {
            return params.value.toLocaleDateString();
        },
        priorityFormatter(params) {
            try {
                return params.value + " - " + this.priorities.find(p => p.value == params.value).text
            } catch (error) {
                return " ... "                
            }
        },
		async onRowDoubleClicked(params){
			console.log("rowDoubleClicked",params)
            // doppio click su riga selezionata la deseleziona
            if(this.currActionId == params.data.id) {
                this.currActionId = 0
                this.clonable = false
            } else {
                this.currActionId = params.data.id
                this.clonable = !!params.data.donets || !!params.data.approvedts
                console.log("clonable",this.clonable)
            }
            // forzo un megaredraw
            await this.refreshActions()
            // this.gridApi.forEachNode((node) => {
            //     console.log("node",node.data.id,this.currActionId)
            //     if (node.data.id == this.currActionId) {
            //         console.log("!")
            //         this.gridApi.redrawRows({force: true, rowNodes: [node]});
            //     }
            // });
        },
		async onRowClicked(params){
			console.log("rowClicked",params)
            // click su riga selezionata la deseleziona
            if(this.currActionId == params.data.id) {
                this.currActionId = 0
                this.clonable = false
            } else {
                this.currActionId = params.data.id
                this.clonable = !!params.data.donets || !!params.data.approvedts
                console.log("clonable",this.clonable)
            }
            // forzo un megaredraw
            await this.refreshActions()
        },
        async onApprovedCellClicked(params){
            console.log("onApprovedCellClicked",params)
            if(params.data.approvedts) {
                this.formApproveRO = true
                let data = await API.getActionApproveData(params.data.id, this.section)
                this.formApprove.agreedwith = data.agreed_with
                this.formApprove.description = data.notes    
                this.approveActionDlg = true
                return
            }
            if(!this.machine) return
            this.formApproveRO = false
            this.approveActionDlg = !this.marsilli
            this.formApprove = {
                agreedwith: "",
                description: "",
                actionid: params.data.id,
            }
        },
        async onDoneCellClicked(params){
            console.log("onDoneCellClicked",params)
            if(params.data.donets) {
                this.formDoneRO = true
                let data = await API.getActionDoneData(params.data.id, this.section)
                this.formDone.agreedwith = data.agreed_with
                this.formDone.description = data.notes    
                this.doneActionDlg = true
                return
            }
            if(!this.machine) return
            this.doneActionDlg = this.marsilli
            this.formDone = {
                agreedwith: "",
                description: "",
                actionid: params.data.id,
            }
        },
        async onEditCellClicked(params){
            console.log("onEditCellClicked",params)
            if(params.data.donets || params.data.approvedts) return
            this.editId = params.data.id
            this.formAction = { issueid:this.issue.id, no: params.data.no, ts: this.toYYYYMMDD(new Date(params.data.ts)), duets: this.toYYYYMMDD(new Date(params.data.duets)), action: params.data.action , owner: params.data.owner, catid: params.data.catid, respid: params.data.respid, phaseid: params.data.phaseid, statusid: params.data.statusid, prioritylevel: params.data.prioritylevel, }
            this.addActionDlg = true
        },
        async onDeleteCellClicked(params){
            console.log("onDeleteCellClicked",params)
            if(params.data.donets || params.data.approvedts) return
            // chiedo conferma
            this.$bvModal.msgBoxConfirm("Are you sure you want to delete this action ?", {
                title: "Confirm Deletion",
                okTitle: "OK, Delete",
                cancelTitle: "Cancel",
                footerClass: "p-2",
                hideHeader: true,
                centered: true
            }).then(async (value) => {
                if (value) {
                    // l'utente ha confermato l'eliminazione
                    await API.deleteAction(params.data.id, this.section)
                    this.refreshActions()
                }
            });
            this.formDelete = { actionid: params.data.id }
            this.deleteActionDlg = true
        },
        onGridReady(params) {
			console.log("Grid Ready")
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
			// this.columnApi.applyColumnState({
			// 	state: [{ colId: 'datefrom', sort: 'desc' }],
			// 	defaultState: { sort: null },
			// });
        },
		// eslint-disable-next-line no-unused-vars
        onFirstDataRendered(event) {
            if(this.currTab==0) {
                this.columnApi.autoSizeAllColumns();
				console.log("autoSizeAllColumns1")
			}
        },
        getRowClass(params) {
            // Se vuoi assegnare una classe CSS alla riga della "Toyota"
            // return params.data.make === "Toyota" ? 'highlight-row' : '';
            let classe = (params.data.id == this.currActionId) ? "rowsel" : ""
            console.log("getRowClass",params.data.id,classe)
            return classe
        }
    }
}

</script>
<style>
div.actions div.card {
    margin: 0px;
}
.rowsel {
    background-color: lightcoral !important;
}
div.actions .check span div {
    font-size: x-large;
    display: flex;
    align-items: center;
}
div.actions .pointer {
    cursor: pointer;
}
</style>
<style scoped>
div.actions button {
	background-color: #9a240d !important;
	border-color: #9a240d !important;
	margin-bottom: 10px;
}
div.actions button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
div.actions button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
</style>
